/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import * as VueGoogleMaps from 'vue2-google-maps';
import VueSignaturePad from 'vue-signature-pad';
import VueObserveVisibility from 'vue-observe-visibility'

import router from './router';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader

require('./bootstrap');
import 'vuetify/dist/vuetify.min.css';

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vuetify
const vuetifyOptions = {
    rtl: true,
    theme: {
        primary: '#021652',
        secondary: '#67eed5',
        accent: '#479aa1',
        error: '#b71c1c'
    }
}
import Vuetify from 'vuetify'
Vue.use(Vuetify, vuetifyOptions);
Vue.use(VueSignaturePad);
Vue.use(VueObserveVisibility)


// Your personal API key.
const API_KEY = process.env.MIX_GOOGLE_MAPS_API_KEY;

const CALLBACK_NAME = 'gmapsCallback';
//MainAPp
Vue.component('main-app', require('./components/MainApp.vue').default);
//MapLoader
Vue.component('map-component', require('./components/GoogleMapLoader.vue').default);
Vue.use(VueGoogleMaps, {
    load: {
        key: API_KEY,
        libraries: 'places,directions'
    },
})

export default new Vuetify({
    icons: {
        iconfont: 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
})
//Map Directions
Vue.component('map-directions', require('./components/GoogleRenderRoute.vue').default);
//Popup modal
Vue.component('popUp-modal', require('./components/popUpModal.vue').default);
//navigation
Vue.component('top-nav', require('./components/TopNavigation.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    router,
    vuetify: new Vuetify(vuetifyOptions)
});

